"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedbackDialogClasses = exports.default = void 0;
exports.getFeedbackDialogUtilityClass = getFeedbackDialogUtilityClass;
var _base = require("@ori-ui/mui-bundle/base");
function getFeedbackDialogUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('MuiOriFeedbackDialog', slot);
}
const feedbackDialogClasses = exports.feedbackDialogClasses = (0, _base.generateUtilityClasses)('MuiOriFeedbackDialog', ['root', 'banner', 'backdrop', 'closeButton', 'dialogGrid', 'content', 'header', 'text', 'message', 'actions', 'severityError', 'severityInfo', 'severitySuccess', 'severityWarning']);
var _default = exports.default = feedbackDialogClasses;
//# sourceMappingURL=feedbackDialogClasses.js.map